<template>
  <v-layout
    v-if="activeFolder.attached_folders.status !== 'attached'"
    align-center
    justify-end
    row
  >

    <!-- Apensar -->
    <attach-folder
      v-if="canBeAttached"
      :folder="activeFolder"
    />

    <!-- Request Folder -->
    <v-btn
      color="black"
      dark
      v-if="canBeRequestFolder"
      @click="requestFolder()"
    >
      <v-icon small left>mdi-folder-network</v-icon>
      Solicitar
    </v-btn>

    <!--  Archived Folder  -->
    <archive-folder-dialog />

    <!-- Sent to Administrative Unit / User -->
    <transact-folder
    v-if="canBeSentFolder"/>

    <!-- Receive or Decline Folder -->

    <receive-or-decline-folder :folderId="activeFolder.id" :canBeReceiveFolder="canBeReceiveFolder"/>

    <!-- Sent to Revision -->
    <v-btn
      color="warning"
      v-if="canBeSentFolderToRevision"
      @click="showSendToReviewDialog = true"
    >
      <v-icon small left>mdi-file-send</v-icon>
      Enviar para revisão
    </v-btn>

    <send-folder-to-review-dialog
      :show="showSendToReviewDialog"
      @close="showSendToReviewDialog = false"
    />

    <!-- Destroy a Folder -->
    <destroy-folder-dialog />
    <!-- Destroy a Folder -->


  </v-layout>
</template>

<script>
  import ArchiveFolderDialog from '@/components/folder/show/toolbar/action/ArchiveFolderDialog';
  import DestroyFolderDialog from '@/components/folder/show/toolbar/action/DestroyFolderDialog';
  import ReceiveOrDeclineFolder from '@/components/folder/show/toolbar/action/ReceiveOrDeclineFolder';
  import SendFolderToReviewDialog from '@/components/folder/show/toolbar/action/SendFolderToReviewDialog';
  import AttachFolder from '@/components/folder/show/toolbar/action/AttachFolder';
  import TransactFolder from '@/components/folder/show/toolbar/action/TransactFolder';
  import foldersService from '@/services/FoldersService';

  export default {
    name: 'ActionPrimary',
    components: {
      ArchiveFolderDialog,
      DestroyFolderDialog,
      ReceiveOrDeclineFolder,
      SendFolderToReviewDialog,
      AttachFolder,
      TransactFolder,
    },
    data() {
      return {
        dialog: false,
        archiveLoading: false,
        showSendToReviewDialog: false,
      };
    },
    props: {
      canBeSentFolder: {
        type: Boolean,
        default: false,
      },
      canBeSentFolderToRevision: {
        type: Boolean,
        default: false,
      },
      canBeReceiveFolder: {
        type: Boolean,
        default: false,
      },
      canBeRequestFolder: {
        type: Boolean,
        default: false,
      },
      canBeAttached: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      activeFolder() {
        return this.$store.getters.activeFolder;
      },
    },
    methods: {
      cancel() {
        this.dialog = false;
      },
      requestFolder() {
      },
      archiveFolder() {
        this.archiveLoading = true;
        foldersService.archiveFolder(this.activeFolder.id)
          .then(() => {
            this.$router.push('/pastas/entrada');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              timeout: 6000,
              color: 'success',
              message: 'O processo foi arquivado com sucesso.',
              messageIcon: 'mdi-check',
            });
          })
          .finally(() => {
            this.archiveLoading = false;
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/FolderPrimaryAction.vue